import type { CustomMetadataStateByDatasetByAccountId } from '@/data/reporting/state/CustomMetadataState';
import type { WiwState } from '@/store';

// Perhaps this selector should be called "getCustomMetadataStateByDatasetByAccountId"
// The "as CustomMetadataStateByDatasetByAccountId" clause isn't strictly required but
// may be helpful for clarity and code navigation purposes
export const getCustomMetadata = (state: WiwState) =>
  state.data.reporting.customMetadata as CustomMetadataStateByDatasetByAccountId;
